/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ref_TitleInputs */

const en_to_csv_ref_title = /** @type {(inputs: To_Csv_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How each JSON value becomes a cell`)
};

const ko_to_csv_ref_title = /** @type {(inputs: To_Csv_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 JSON 값이 칸이 되는 방식`)
};

const ja_to_csv_ref_title = /** @type {(inputs: To_Csv_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各 JSON 値がセルになる仕組み`)
};

/**
* | output |
* | --- |
* | "How each JSON value becomes a cell" |
*
* @param {To_Csv_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ref_title = /** @type {((inputs?: To_Csv_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ref_title(inputs)
	if (locale === "ko") return ko_to_csv_ref_title(inputs)
	return ja_to_csv_ref_title(inputs)
});